import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { getCourseList, CourseItem, getClassList, ClassItem } from "@/service";
import Mask from '@/components/Mask';
import message from '@/components/Message';
import Loading from '@/components/Loading';
import IfRender from '@/components/IfRender';
import useSubmitCourse from '@/hooks/submitCourse';
import { setSessionValue, SESSION_KEYS } from '@/service/sessionStore';
import { extendsUrlSearch, isIOS, goToLogin } from '@/utils'
import ClassItemUI from './ClassItem';
import s from './index.module.css';


const NO_LOGIN_CODE = 10000;

const DEFAULT_CLASS_RES = {courses: [], remainSelections: 0, hasSelected: false};


const Course: React.FC = () => {

  const nav = useNavigate();

  const  { submitCourse } = useSubmitCourse();

  const [loading, setLoading] = useState(true);
  // 选班剩余机会
  const [state, setState] = useState({
    remainNum: 0,
    hasSelect: false
  });
  // 课程列表和班级列表
  const [courseList, setCourseList] = useState<CourseItem[]>([]);
  const [classList, setClassList] = useState<ClassItem[]>([]);

  // 当前选中的课程和班级
  const [currCourse, setCurrCourse] = useState<CourseItem>();
  const [currClass, setCurrClass] = useState<ClassItem>();

  // 是否显示课程列表
  const [showCourseList, toggleCourseList] = useState(false);
  // 用户是否选择了班级
  const [userSelected, setUserSelected] = useState(false);

  const hasOnlyOneCourse = useMemo(() => courseList.length === 1, [courseList])


  const isDisabled = useMemo(() => {
    if(state.remainNum === 0 // 无选班机会
      || !userSelected // 用户未选择班级
    ) {
      return true;
    }
    return false;
  }, [loading, state, userSelected])

  const fetchClassList = (courseId: number) => {
    getClassList({courseId}).then(({code, data}) => {
      setLoading(false)
      setUserSelected(false);
      if(code !== 0) {
        message.info('获取班级列表失败');
        return;
      }
      const {courses, remainSelections, hasSelected} = data || DEFAULT_CLASS_RES;
      setState({ remainNum: remainSelections, hasSelect: hasSelected })
      setClassList(courses);
      const selectedClass = courses.find(item => item.selected);
      setCurrClass(selectedClass);
    }).catch((err) => {
      setLoading(false)
      console.log(err);
    });
  }

  useEffect(() => {
    setLoading(true)
    getCourseList().then(({code, data}) => {
      if(code === NO_LOGIN_CODE) {
        // 未登录
        goToLogin()
        return;
      }
      if(code !== 0 || data?.sourceCourses?.length === 0) {
        nav('/result', {
          state: {
            type: 'error',
            title: '无选班课来源课权, 请联系老师'
          }
        });
        return;
      }

      const list = data?.sourceCourses || [];
      setCourseList(list);
      setCurrCourse(list[0]);
      fetchClassList(list[0]?.courseId);
      return;

    }).catch((err) => {
      console.log(err);
      message.info('获取课程列表失败');
    });
  }, []);

  const handleToggleCourseList = () => {
    if(hasOnlyOneCourse) {
      return
    }
    toggleCourseList(c => !c)
  }

  const handleSelectCourse = (course: CourseItem) => {
    toggleCourseList(false);
    setCurrCourse(course);
    fetchClassList(course.courseId);
  }

  const handleSubmit = () => {
    if(isDisabled) {
      return;
    }
    if(!currCourse || !currClass) {
      message.info('请选择课程和班级');
      return;
    }
    setSessionValue(SESSION_KEYS.SELECTED_CLASS, JSON.stringify(currClass));


    if(currClass.selected) {
      nav('/result', {
        state: {
          type: 'success',
          title: '选班成功～'
        }
      });
      return
    }

    // 需要填写地址
    if(currClass.hasMaterial) {
      const queryStr = extendsUrlSearch({
        courseId: currCourse.courseId,
        classId: currClass.courseId
      })
      nav(`/address${queryStr}`);
      return;
    }
     // 无需填写地址 提交选课数据
    submitCourse({
      courseId: currCourse.courseId,
      classId: currClass.courseId
    })
  }

  const handleSelectClass = (item: ClassItem) => {
    setCurrClass(item);
    setUserSelected(true);
  }

  return <div className={`${s.wrap} ${isIOS && s.wrapIos}`}>


    <Loading loading={loading} />

    <div className={s.course}>
      <span className={s.courseTip}>来源课程:</span>
      <div className={s.selectedCourse} onClick={handleToggleCourseList}>
        <div className={s.selectedCourseName}>{currCourse?.courseName}</div>
        <IfRender show={!hasOnlyOneCourse}>
          <span className={showCourseList ? s.activeTriangle : s.triangle}/>
        </IfRender>
      </div>
    </div>

    <div className={s.tips}>
      <div>选班状态: <span className='strong'>{`${state.hasSelect ? '已选班' : '未选班'}`}</span></div>
      <div>选班剩余机会: <span className='strong'>{state.remainNum}</span></div>
    </div>

    <Mask visible={showCourseList} onClick={() => toggleCourseList(false)}>
      <div className={`${s.courseList} ${isIOS && s.isIos}`}>
        {courseList.map(item => (
          <div
            key={item.courseId}
            className={`${s.courseItem} ${currCourse?.courseId === item.courseId ? s.active : ''}`}
            onClick={() => handleSelectCourse(item)}
          >
            {item.courseName}
          </div>
        ))}
      </div>
    </Mask>



    <div className={s.list}>
      {
        classList.map((item) => (
          <ClassItemUI
            key={item.courseId}
            currId={currClass?.courseId}
            setCurrClass={handleSelectClass}
            item={item}
          />
        ))
      }
    </div>
    <div className={`${s.btn} ${isDisabled && s.disabled}`} onClick={handleSubmit}>确认提交</div>
  </div>;
};
export default Course;
